import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import globalTranslations from '../../../../i18n/globalTranslations';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import { labels } from '../../../../util/formLabels';

const CheckoutRegistrationButton = ({ checkoutStore, showLabel = true }) => {
  const { checkoutIsLoading, registerCustomer } = checkoutStore;

  const disabled = checkoutIsLoading;

  const button = (
    <Button
      id="register"
      onClick={registerCustomer}
      disabled={disabled}
      className="CheckoutRegistrationButton__text"
    >
      <FormattedMessage {...globalTranslations.registerTitle} />
    </Button>
  );

  return (
    <div className="CheckoutRegistrationButton">
      {showLabel ? (
        <span>
          {labels.registerVisitorCustomer}
          {button}
        </span>
      ) : (
        button
      )}
    </div>
  );
};

CheckoutRegistrationButton.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  showLabel: PropTypes.bool,
};

export default inject('checkoutStore')(observer(CheckoutRegistrationButton));
